import React from "react";
import { Route } from "react-router-dom";
import { useAppContext } from "../libs/appContextLib";
import {Redirect} from "react-router";
import { consumeDesktopLinkRedirect } from "../utils/desktopLinkRedirect";

function querystring(name, url = window.location.href) {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.searchParams.get(name);
  } catch (_error) {
    return null;
  }
}
export default function UnauthenticatedRoute({ children: _children, ...rest }) {
  const { isAuthenticated } = useAppContext();
  const desktopRedirectRef = React.useRef(null);
  if (
    isAuthenticated &&
    querystring("desktop_link") === "1" &&
    desktopRedirectRef.current === null
  ) {
    desktopRedirectRef.current = consumeDesktopLinkRedirect() || "/";
  }
  const redirect = isAuthenticated && querystring("desktop_link") === "1"
    ? desktopRedirectRef.current
    : querystring("redirect");
  return (
    <Route {...rest}>
     {isAuthenticated  &&
        <Redirect to={redirect === "" || redirect === null ? "/" : redirect} /> }
        </Route>
    //   {/*{!isAuthenticated ? (*/}
    //   {/*  children*/}
    //   {/*) : (*/}
    //   {/*  <Redirect to={redirect === "" || redirect === null ? "/" : redirect} />*/}
    //   {/*)}*/}
    // </Route>
  );
}
